import {Steps} from 'antd';
import './style.css';
import React from 'react';

type RoadStepItem = {
    title: string;
    description: string;
};

type RoadStepConfig = {
    color: string;
    width: string;
    items: RoadStepItem[];
};

type RoadStepProps = {
    config: RoadStepConfig;
    step: number;
    onChange?: ((current: number) => void) | undefined;
    declined?: boolean;
};

const RoadStep = ({config, step, onChange = undefined, declined}: RoadStepProps) => {
    return (
        <div className={`${config.width ?? config.width}`}>
            <Steps
                current={step}
                status={(config.items.length - 1) === step ? 'finish' : declined ? 'error' : 'process'}
                items={config.items}
                className={`roadstep-${config.color ?? 'orange'}`}
                labelPlacement="vertical"
                onChange={onChange}
            />
        </div>
    );
};

export default RoadStep;
